import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import Card from '../../components/common/Card/Card';

const Trial: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      navigate(`/register?trial_token=${encodeURIComponent(token)}`, {
        replace: true,
      });
    }
  }, [token, navigate]);

  if (token) {
    return (
      <PageContainer>
        <div className="max-w-md mx-auto mt-10 text-center">
          <p className="text-gray-600">Redirecting to sign up...</p>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <div className="max-w-md mx-auto mt-10">
        <Card>
          <div className="text-center space-y-4">
            <h2 className="text-xl font-bold text-gray-800">Invalid trial link</h2>
            <p className="text-gray-600">
              This trial link is invalid or has already been used. You can still
              create an account to get started.
            </p>
            <Link
              to="/register"
              className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-primary hover:bg-primary/90 rounded-md"
            >
              Sign up
            </Link>
          </div>
        </Card>
      </div>
    </PageContainer>
  );
};

export default Trial;
